import { api } from '@core/api/client';
import type { LatestPositionsResponse } from '@core/types/api';

export const positionsService = {
  /**
   * The map's primary payload, and the snapshot the SSE stream falls back to.
   *
   * Carries `serverTime` so the client can correct for its own clock drift before
   * computing fix ages -- a machine running twenty minutes fast would otherwise paint the
   * entire fleet as offline.
   */
  fetchLatest: async (signal?: AbortSignal): Promise<LatestPositionsResponse> =>
    (await api.get<LatestPositionsResponse>('/api/v1/positions/latest', { signal })).data,
};
